import { FormProvider } from 'react-hook-form';
import { useDownloadActivationCodesForm } from './hooks';
import { DownloadActivationCodesFormPresentation } from './presentations';

/**
 * アクティベーションコードCSVダウンロードフォームのコンテナコンポーネント
 * NOTE: Suspenseを使用するhookを含むため、親コンポーネントでSuspenseでラップしてください
 */
export const DownloadActivationCodesForm: React.FC = () => {
  const {
    state: { methods, isButtonDisabled, searchAction },
    actions: { handleOnSubmit, handleClientChange },
  } = useDownloadActivationCodesForm();

  return (
    <FormProvider {...methods}>
      <DownloadActivationCodesFormPresentation
        isButtonDisabled={isButtonDisabled}
        searchAction={searchAction}
        onClientChange={handleClientChange}
        onSubmit={handleOnSubmit}
      />
    </FormProvider>
  );
};
